import styled from '@emotion/styled';

const PanelTitle = styled.div`
  font-family: 'Urbanist';
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 2rem;
`;

export default PanelTitle;
